import toast from "react-hot-toast";
import BaseListPresenter from "../../../../base/BaseListPresenter";

class RecordCompanyListPresenter extends BaseListPresenter {
  constructor(
    view,
    findObjectUseCase,
    countObjectUseCase,
    upsertUseCase,
    deleteObjectUseCase,
  ) {
    super(
      view,
      findObjectUseCase,
      countObjectUseCase,
      upsertUseCase,
      deleteObjectUseCase,
    );
    this.upsertUseCase = upsertUseCase;
    this.deleteObjectUseCase = deleteObjectUseCase;
  }

  init() {
    this.limit = 20;
    this.where = {
      $and: [{ company: { $ne: null } }, { company: { $ne: "" } }],
    };
    this.search = {};
    this.filter = {};
    this.include = ["all"];
    this.keys = undefined; // if keys are specified, only those keys will be returned
    this.sort = { createdAt: -1 };
    this.progress = true;
    this.reset();
  }

  async getObjects() {
    this.showProgress();
    this.reset();
    await this.countObjects();
    await this.findObjects();
    this.hideProgress();
  }

  createQuery() {
    const skip = (this.current - 1) * this.limit;
    const query = {
      limit: this.limit,
      skip: skip,
      where: {
        ...this.where,
        ...this.search,
        ...this.filter,
        ...this.filterDate,
      },

      include: this.include,
    };
    if (this.sort) {
      query.sort = this.sort;
    }
    const keys = this.keys || this.view.getKeys() || [];
    if (keys.length > 0) {
      query.keys = keys;
    }
    return query;
  }

  async countObjects() {
    try {
      const collection = this.view.getCollectionName();
      const query = this.createQuery();
      const { count } = await this.countObjectUseCase.execute(collection, {
        where: query.where,
      });

      this.count = count;
      this.view.setCount(this.count);
    } catch (error) {
      this.view.showError(error);
    }
  }

  async findObjects() {
    const collection = this.view.getCollectionName();
    const query = this.createQuery();

    try {
      this.findObjectUseCase.abort();
      const objects = await this.findObjectUseCase.execute(collection, query);
      this.objects = this.objects.concat(objects);
      this.view.setTotal(this.objects.length);
      this.view.setObjects(this.objects);
    } catch (error) {
      this.view.showError(error);
    }
  }

  searchSubmit(search) {
    const [nameQuery] = search.$or.filter((item) =>
      Object.keys(item).includes("fullName"),
    );

    const splitTerm = nameQuery.fullName.$regex
      .trim()
      .replace(/\s+/g, " ")
      .split(/\s+/);

    const permutator = (inputArr) => {
      let result = [];

      const permute = (arr, m = []) => {
        if (arr.length === 0) {
          result.push(m);
        } else {
          for (let i = 0; i < arr.length; i++) {
            let curr = arr.slice();
            let next = curr.splice(i, 1);
            permute(curr.slice(), m.concat(next));
          }
        }
      };

      permute(inputArr);

      return result;
    };

    // Get all word permutations
    const permutations = permutator(splitTerm);

    // Build regex from permutations
    const regexPattern = permutations
      .map((permutation) => permutation.join("\\s+"))
      .join("|");

    const searchQuery = { fullName: { $regex: regexPattern, $options: "i" } };

    this.showProgress();
    this.reset();
    this.search = searchQuery;
    this.getObjects();
  }

  filterSubmit(where) {
    this.reset();
    this.filter = { ...this.filter, ...where };
    this.getObjects();
  }

  async onClickDeleteItem(index) {
    const object = this.objects[index];
    const collection = this.view.getCollectionName();
    try {
      await this.view.showDialog({
        title: "Delete Data?",
        message: "Are you sure you want to delete?",
      });

      await this.deleteObjectUseCase.execute(collection, object.id);
      const index = this.objects.indexOf(object);
      this.objects.splice(index, 1);
      this.view.setObjects(this.objects);
    } catch (error) {
      this.view.hideProgress();
      this.view.showError(error);
    }
  }

  // async saveImportedData(importedData, uploadType) {
  //   toast.promise(
  //     new Promise(async (resolve, reject) => {
  //       try {
  //         // Validate all records first
  //         const invalidRecords = [];

  //         console.log("importedData", importedData);

  //         console.log("uploadType", uploadType);

  //         const _uploadTypePDF = uploadType === "isScannedPDF" ? true : false;
  //         const _uploadTypeCSV = uploadType === "isScannedCSV" ? true : false;

  //         importedData.forEach((data, index) => {
  //           const { company, lastName, caseNumber, caseNo } = data || {};
  //           const errors = [];
  //           console.log("caseNumber", caseNumber?.trim());
  //           // if (!company?.trim()) {
  //           //   errors.push("Company is required");
  //           // }
  //           // if (!lastName?.trim()) {
  //           //   errors.push("Last Name is required");
  //           // }
  //           // if (!caseNumber?.trim() || !caseNo?.trim()) {
  //           //   errors.push("CaseNo is required");
  //           // }
  //           if (!caseNumber?.trim() && !caseNo?.trim()) {
  //             errors.push("Case No is required");
  //           }

  //           if (errors.length > 0) {
  //             invalidRecords.push({
  //               row: index + 1,
  //               errors: errors.join(", "),
  //             });
  //           }
  //         });

  //         // If there are invalid records, reject with detailed error
  //         if (invalidRecords.length > 0) {
  //           const errorMessage = invalidRecords
  //             .map((record) => `Row ${record.row}: ${record.errors}`)
  //             .join("; ");
  //           reject(new Error(errorMessage));
  //           console.log("error message", errorMessage);
  //           return;
  //         }

  //         // Process valid records
  //         for (const data of importedData) {
  //           const {
  //             court,
  //             courtType,
  //             company,
  //             caseNo,
  //             caseNumber,
  //             natureOfCase,
  //             caseType,
  //             branch,
  //             firstName,
  //             middleName,
  //             lastName,
  //             alias,
  //             typeOfCourt,
  //             ...rest
  //           } = data || {};

  //           // Generate a unique composite key
  //           const compositeKey = `${
  //             caseNumber || caseNo
  //           }|${lastName}|${firstName}|${middleName}`.toLowerCase();

  //           const normalizedCaseNumber = (caseNumber ?? caseNo ?? "")
  //             .toString()
  //             ?.trim();

  //           const extracted = {
  //             ...rest,
  //             uniquePersonCaseId: compositeKey,
  //             company: company?.trim() || "",
  //             branch: parseInt(branch) || "",
  //             caseType: natureOfCase?.trim() || caseType?.trim(),
  //             courtType:
  //               courtType?.trim() || court?.trim() || typeOfCourt?.trim(),
  //             // caseNumber: caseNumber?.trim() || caseNo?.trim(),
  //             caseNumber: normalizedCaseNumber,
  //             firstName: firstName?.trim(),
  //             middleName: middleName?.trim(),
  //             lastName: lastName?.trim(),
  //             alias: alias?.trim(),
  //             fullName: `${firstName || ""} ${middleName || ""} ${lastName} ${
  //               alias || ""
  //             }`
  //               ?.trim()
  //               ?.replace(/\s+/g, " "),
  //             isScanned: true,
  //             isScannedCSV: _uploadTypeCSV,
  //             isScannedPDF: _uploadTypePDF,
  //             acl: {
  //               read: ["*"],
  //               write: ["*"],
  //             },
  //           };

  //           delete extracted.typeOfCourt;

  //           await this.upsertUseCase.execute("records", extracted);
  //           console.warn("extracted", extracted);
  //         }
  //         resolve();
  //       } catch (error) {
  //         reject(error);
  //       } finally {
  //         this.getObjects();
  //       }
  //     }),
  //     {
  //       loading: "Saving data...",
  //       success: "Data Saved successfully!",
  //       error: (err) => `Failed to save data. ${err.message || err}`,
  //     },
  //     { position: "top-right" }
  //   );
  // }

  async saveImportedData(importedData, uploadType) {
    toast.promise(
      new Promise(async (resolve, reject) => {
        try {
          // Validate all records first
          const invalidRecords = [];
          const processedKeys = new Set();
          const duplicatesWithinFile = [];

          console.log("importedData", importedData);
          console.log("uploadType", uploadType);

          const _uploadTypePDF = uploadType === "isScannedPDF" ? true : false;
          const _uploadTypeCSV = uploadType === "isScannedCSV" ? true : false;

          // First pass: validate and check for duplicates within the file
          const validRecords = [];

          importedData.forEach((data, index) => {
            const {
              company,
              lastName,
              caseNumber,
              caseNo,
              firstName,
              middleName,
            } = data || {};
            const errors = [];

            if (!caseNumber?.trim() && !caseNo?.trim()) {
              errors.push("Case No is required");
            }

            if (errors.length > 0) {
              invalidRecords.push({
                row: index + 1,
                errors: errors.join(", "),
              });
              return;
            }

            // Generate composite key to check duplicates within file
            const compositeKey = `${
              caseNumber || caseNo
            }|${lastName}|${firstName}|${middleName}`.toLowerCase();

            if (processedKeys.has(compositeKey)) {
              duplicatesWithinFile.push({
                row: index + 1,
                name: `${firstName || ""} ${middleName || ""} ${
                  lastName || ""
                }`.trim(),
                caseNumber: (caseNumber || caseNo)?.trim(),
              });
              return;
            }

            processedKeys.add(compositeKey);
            validRecords.push(data);
          });

          // If there are invalid records, reject with detailed error
          if (invalidRecords.length > 0) {
            const errorMessage = invalidRecords
              .map((record) => `Row ${record.row}: ${record.errors}`)
              .join("; ");
            reject(new Error(errorMessage));
            return;
          }

          // Warn about duplicates within file but continue
          if (duplicatesWithinFile.length > 0) {
            console.warn(
              "Duplicates within file (skipped):",
              duplicatesWithinFile,
            );
          }

          // Second pass: save to database and handle existing duplicates
          const newRecords = [];
          const skippedExisting = [];

          for (const data of validRecords) {
            const {
              court,
              courtType,
              company,
              caseNo,
              caseNumber,
              natureOfCase,
              caseType,
              branch,
              firstName,
              middleName,
              lastName,
              alias,
              typeOfCourt,
              ...rest
            } = data || {};

            // Generate a unique composite key
            const compositeKey = `${
              caseNumber || caseNo
            }|${lastName}|${firstName}|${middleName}`.toLowerCase();

            const normalizedCaseNumber = (caseNumber ?? caseNo ?? "")
              .toString()
              ?.trim();

            const extracted = {
              ...rest,
              uniquePersonCaseId: compositeKey,
              company: company?.trim() || "",
              branch: parseInt(branch) || "",
              caseType: natureOfCase?.trim() || caseType?.trim(),
              courtType:
                courtType?.trim() || court?.trim() || typeOfCourt?.trim(),
              caseNumber: normalizedCaseNumber,
              firstName: firstName?.trim(),
              middleName: middleName?.trim(),
              lastName: lastName?.trim(),
              alias: alias?.trim(),
              fullName: `${firstName || ""} ${middleName || ""} ${lastName} ${
                alias || ""
              }`
                ?.trim()
                ?.replace(/\s+/g, " "),
              isScanned: true,
              isScannedCSV: _uploadTypeCSV,
              isScannedPDF: _uploadTypePDF,
              acl: {
                read: ["*"],
                write: ["*"],
              },
            };

            delete extracted.typeOfCourt;

            try {
              await this.upsertUseCase.execute("records", extracted);
              newRecords.push(extracted);
              console.log("Saved:", extracted.fullName);
            } catch (error) {
              // Check if it's a duplicate key error (MongoDB error code 11000)
              if (
                error.code === 11000 ||
                error.message?.includes("duplicate") ||
                error.message?.includes("unique")
              ) {
                skippedExisting.push({
                  name: extracted.fullName,
                  caseNumber: extracted.caseNumber,
                });
                console.log("Skipped duplicate:", extracted.fullName);
              } else {
                // If it's a different error, throw it
                console.error("Error saving record:", error);
                throw error;
              }
            }
          }

          // Build success message with statistics
          let message = "";
          if (newRecords.length > 0) {
            message = `${newRecords.length} new record(s) saved successfully!`;
          }

          if (skippedExisting.length > 0) {
            if (message) message += " ";
            message += `${skippedExisting.length} duplicate(s) skipped (already exist in database).`;
          }

          if (duplicatesWithinFile.length > 0) {
            if (message) message += " ";
            message += `${duplicatesWithinFile.length} duplicate(s) within file skipped.`;
          }

          if (!message) {
            message = "No new records to save.";
          }

          console.log("Import summary:", {
            new: newRecords.length,
            skippedExisting: skippedExisting.length,
            skippedWithinFile: duplicatesWithinFile.length,
            total: importedData.length,
          });

          resolve(message);
        } catch (error) {
          reject(error);
        } finally {
          this.getObjects();
        }
      }),
      {
        loading: "Saving data...",
        success: (msg) => msg || "Data Saved successfully!",
        error: (err) => `Failed to save data. ${err.message || err}`,
      },
      { position: "top-right" },
    );
  }
}

export default RecordCompanyListPresenter;
